import '../../scss/pages/cart.scss';
import Vue from "vue";
import CuttableProductPreview from "@danhoss/cuttable-product-preview-component";
import {renderImagePopup} from "../libraries/ImagePopup";
import {renderAdditionalBox} from '../vue/modules/additional-products';
import 'swiper/dist/css/swiper.css';
import Swiper from 'swiper';

const Carousels = {
    associationSlider: null,

    init() {
        const associationGiftSelector = '#modal-wrapper-content .swiper-container';
        Carousels.associationSlider = new Swiper(associationGiftSelector, {
            slidesPerView: 'auto',
            spaceBetween: 20,
            preloadImages: false
        });
    }
};

function initializeCuttable() {
    document.querySelectorAll('.cuttable-image').forEach(cuttableImageContainer => {
        const vue = new Vue({
            components: {
                CuttableProductPreview
            }
        });
        vue.$mount(cuttableImageContainer);
    });
}

function bindImagePopupHandler() {
    const anchors = document.querySelectorAll('.cart-content .cart-position a.image-product');

    for (let anchor of anchors) {
        const imageUrl = anchor.getAttribute('href');

        anchor.addEventListener('click', event => {
            event.preventDefault();
            renderImagePopup(imageUrl)
        });
    }

    return this;
}

function bindChatOpen() {
    let zenbox = document.querySelector('#zenbox-open');
    if (null !== zenbox) {
        zenbox.addEventListener('click', event => {
            event.preventDefault();
            if (typeof zE == 'function') {
                if (window.zE.widget === 'messenger') {
                    zE("messenger", "show");
                    zE("messenger", "open");
                } else {
                    zE("webWidget", "show");
                    zE("webWidget", "open");
                }
            }
        });
    }

    return this;
}

function initializeAlertShipping() {
    if (isAlertShipping == 0) return;

    let alertContainerInstance = null;

    const showAlertHandler = () => {
        if (!alertContainerInstance) {
            import(/* webpackChunkName: "alert-shipping-chunk" */ "./../vue/containers/AlertShippingContainer")
                .then(module => {
                    const container = document.createElement('div');
                    document.body.appendChild(container);

                    alertContainerInstance = new Vue(module.default);
                    alertContainerInstance.$mount(container);
                    alertContainerInstance.openModal();
                })
            ;
        } else {
            alertContainerInstance.openModal();
        }
    };

    const goToOrderButton = document.querySelector('#go-to-order');
    if (!goToOrderButton) {
        return;
    }

    goToOrderButton.addEventListener('click', (event) => {
        event.preventDefault();

        showAlertHandler();
        return false;
    });
}

function initializeCoupons() {
    const couponToggle = document.querySelector('#coupon-toggle');
    if (!couponToggle) {
        return;
    }

    couponToggle.addEventListener('click', (event) => {
        event.preventDefault();
        const cartPoints = document.querySelector('.cart-points');

        if (couponToggle.parentElement.classList.contains('open')) {
            couponToggle.parentElement.classList.remove('open');
            if (null !== cartPoints) {
                cartPoints.style.display = 'block';
            }
        } else {
            couponToggle.parentElement.classList.add('open');
            if (null !== cartPoints) {
                cartPoints.style.display = 'none';
            }
        }
        return false;
    });

    const inputCode = document.querySelector(`input[name=kupon]`);
    if (null !== inputCode) {
        inputCode.addEventListener('keypress', (e) => {
            var Ucode=e.keyCode ? e.keyCode : e.charCode;
            if (Ucode == 13) {
                document.location.href='koszyk.php?kupon='+document.koszyk.kupon.value;
                return false;
            } else {
                return true;
            }
        });

        const errorBox = document.querySelector(`#kupon_rabatowy_error`);
        const cartPoints = document.querySelector('.cart-points');

        if (null !== errorBox || inputCode.value !== '') {
            toggleClass('.cart-coupons','block');
            if (null !== cartPoints) {
                cartPoints.style.display = 'none';
            }
        } else {
            toggleClass('.cart-coupons','none');
            if (null !== cartPoints) {
                cartPoints.style.display = 'block';
            }
        }
    }

}

function initializeHelpButton() {
    const helpToggle = document.querySelector('#help-toggle');
    if (!helpToggle) {
        return;
    }

    helpToggle.addEventListener('click', (event) => {
        event.preventDefault();

        if (helpToggle.parentElement.classList.contains('open')) {
            helpToggle.parentElement.classList.remove('open');
        } else {
            helpToggle.parentElement.classList.add('open');
        }
        return false;
    });
}

/**
 * @param {string} element
 * @param {string} status
 */
function toggleClass(element, status) {
    const elementToggle = document.querySelector(element);
    if (!elementToggle) {
        return;
    }

    if (status === 'none') {
        elementToggle.classList.remove('open');
    } else {
        elementToggle.classList.add('open');
    }
}

function initAssociationGift() {
    const showButtons = document.querySelectorAll('.show-association-gift');
    if (showButtons === null || showButtons.length === 0) {
        return;
    }

    const modal = document.createElement('section');
    modal.id = "modal-association-inner";
    modal.innerHTML = '<section class="cart-popup">' +
        '<span class="close-button"><i class="icon icon-close"></i></span>\n' +
        '<header>\n' +
        '   <div class="modal-name">x</div>\n' +
        '   <div class="modal-association-symbol small">y</div>\n' +
        '   <a href="" class="modal-url small">Przejdź do produktu</a>\n' +
        '</header>\n' +
        '        <main id="modal-wrapper-content">\n' +
        '            <div class="swiper-container">\n' +
        '<ul class="swiper-wrapper">\n' +
        '   <li class="swiper-slide association-item">\n' +
        '      <img class="modal-association-image1" src="" width="280" height="280" alt="Zdjęcie" />\n' +
        '   </li>\n' +
        '   <li class="swiper-slide association-item">\n' +
        '      <img class="modal-association-image2" src="" width="280" height="280" alt="Zdjęcie" />\n' +
        '   </li>\n' +
        '</ul>\n' +
        '<br clear="all">\n' +
        '</div><div class="tab-header">Szczegóły produktu</div>\n' +
        '<div class="message"></div>\n' +
        '</main>\n' +
        '</section>';
    document.body.appendChild(modal);

    modal.addEventListener("click", (event) => {
        if (event.target.id === 'modal-association-inner') {
            event.preventDefault();
            toggleShowMore(false, 'modal-association-inner');
            toggleZenBox("show");
        }
    });

    modal.querySelector('span.close-button').addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        toggleShowMore(false, 'modal-association-inner');
        toggleZenBox("show");
    })

    for (let showButton of showButtons) {
        showButton.addEventListener('click', (event) => {
            event.preventDefault();

            const associationGiftId = showButton.getAttribute('data-association-gift-id');

            document.querySelector("#modal-association-inner").querySelector(".modal-association-image1").src = document.querySelector("#"+associationGiftId).getAttribute('data-product-image1');
            document.querySelector("#modal-association-inner").querySelector(".modal-association-image2").src = document.querySelector("#"+associationGiftId).getAttribute('data-product-image2');
            document.querySelector("#modal-association-inner").querySelector(".modal-name").innerHTML = document.querySelector("#"+associationGiftId).getAttribute('data-product-name');
            document.querySelector("#modal-association-inner").querySelector(".modal-association-symbol").innerHTML = document.querySelector("#"+associationGiftId).getAttribute('data-product-symbol');
            document.querySelector("#modal-association-inner").querySelector(".message").innerHTML = document.querySelector("#"+associationGiftId).getAttribute('data-product-technical-description');
            document.querySelector("#modal-association-inner").querySelector(".modal-url").href = document.querySelector("#"+associationGiftId).getAttribute('data-product-url');

            toggleShowMore(true, 'modal-association-inner');

            const mySwiper = document.querySelector('#modal-wrapper-content .swiper-container').swiper;
            if (typeof mySwiper !== 'undefined' && mySwiper !== null) {
                mySwiper.update();
            }

            toggleZenBox("hide");
        })
    }
}

/**
 * @param {boolean} show
 * @param {String} elementName
 */
function toggleShowMore(show, elementName) {
  if (show) {
    document.querySelector("#"+elementName).classList.add("visible");
  } else {
    document.querySelector("#"+elementName).classList.remove("visible");
  }
  document.querySelector('body').style.overflowY = show ? 'hidden' : 'scroll';
}

/**
 * @param {String} action
 */
function toggleZenBox(action)
{
  if (typeof zE == 'function') {
    if (window.zE.widget === 'messenger') {
      zE("messenger", action);
    } else {
      zE("webWidget", action);
    }
  }
}

function includeEditorJs()
{
  const url = new URL(window.location.href);

  if (typeof personalizeEditorUrl === 'undefined') {
      return;
  }
  let editorUrl = personalizeEditorUrl;

  const js = document.createElement("script");
  js.setAttribute("type", "text/javascript");
  js.setAttribute("charset", "utf-8");
  js.setAttribute("src", editorUrl);
  document.head.appendChild(js);
}

function initPersonalizator() {

  const url = new URL(window.location.href);

  const symbol = url.searchParams.get("symbol");
  if (symbol === null || symbol === '') {
    return;
  }

  const action = url.searchParams.get("a");
  if (action !== 'personalize') {
    return;
  }

  const modalBox = document.createElement('section');
  modalBox.id = "modal-personalization-inner";
  modalBox.innerHTML = '<section class="cart-popup">' +
    '  <span><i class="icon icon-close"></i></span>' +
    '  <header>\n' +
    '     <div class="modal-name">Personalizuj</div>\n' +
    '  </header>\n' +
    '  <main id="additional-products-personalized"></main>\n' +
    '</section>';
  document.body.appendChild(modalBox);

  toggleShowMore(true, 'modal-personalization-inner');
  toggleZenBox("hide");

  includeEditorJs();

  modalBox.addEventListener("mousedown", (event) => {
    if (event.target.id === 'modal-personalization-inner') {
      toggleShowMore(false, 'modal-personalization-inner');
      toggleZenBox("show");
    }
  });

  modalBox.querySelector("#modal-personalization-inner section.cart-popup span").addEventListener("click", (event) => {
    event.preventDefault();
    event.stopPropagation();

    toggleShowMore(false, 'modal-personalization-inner');
    toggleZenBox("show");
  });

}

function initialize() {

  initializeCuttable();
  bindImagePopupHandler();
  initializeCoupons();
  initializeHelpButton();
  initAssociationGift();
  renderAdditionalBox();
  bindChatOpen();
  initPersonalizator();

  Carousels.init();
}

document.addEventListener('DOMContentLoaded', initialize);
